<script lang="ts">
    import EmployeeWidget from "$lib/partials/EmployeeWidget.svelte";
    import EmployeeFormGroup from "$lib/partials/EmployeeFormGroup.svelte";
    import {onMount} from "svelte";
    import {getReference} from "$lib/calls/hr";
    import dayjs from "dayjs";
    import Typeahead from "$lib/components/Typeahead.svelte";
    import {asValue} from "$lib/utils/lenkradDate.js";
    import {genderOptions} from "$lib/options";

    export let employee;
    export let editing = false;

    let educationOptions: Array<{ name: string, value: string }> = [];
    let qualificationOptions: Array<{ name: string, value: string }> = [];
    let employmentTitleOptions: Array<{ name: string, value: string }> = [];
    let nationalityOptions: Array<{ name: string, value: string }> = [];
    let maritalStatusOptions: Array<{ name: string, value: string }> = [
        {name: 'Ledig', value: 'single'},
        {name: 'Geschieden', value: 'divorced'},
        {name: 'Verheiratet', value: 'married'},
        {name: 'Verwitwet', value: 'widowed'},
        {name: 'Sonstiger Status', value: 'other'},
    ];


    export let sourceOptions = [
        {name: 'Website', value: 'website'},
    ];
    $: currentContract = employee?.contracts?.find(contract => dayjs(contract.endDate).valueOf() > dayjs().valueOf() && dayjs(contract.startDate).valueOf() < dayjs().valueOf())


    let affiliationEntered = employee.contracts?.sort((a, b) => a.startDate > b.startDate)[0]?.startDate;

    onMount(async () => {
        educationOptions = (await getReference('Schulabschluss')).map(x => ({name: x.value, value: x.key}));
        nationalityOptions = (await getReference('Staatsangehoerigkeiten')).sort((a, b) => a.value < b.value).map(x => ({name: x.value, value: x.key}));
    })
</script>

<EmployeeWidget headline="Stammdaten" collapsible>

    <svelte:fragment slot="left">

        {#if employee.cv?.degree}
            <EmployeeFormGroup
                    {editing}
                    label="Ausbildung"
                    labelFor="education"
                    bind:value={employee.cv.degree}
                    data={educationOptions}>
                {employee.cv.degree || ''}
            </EmployeeFormGroup>
        {/if}


        <EmployeeFormGroup
                {editing}
                label="Aktueller Status"
                labelFor="status"
                bind:value={employee.status}>
            {employee.status }
        </EmployeeFormGroup>


        <EmployeeFormGroup
                label="Konzerneintritt"
                labelFor="employmentEnteredAt"
                type="date">
            {affiliationEntered ? dayjs(asValue(affiliationEntered), 'YYYY-MM-DD').format('DD.MM.YYYY') : ''}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                label="Anstellung als"
                labelFor="employmentTitle"
        >
            {currentContract?.hiredAs || ''}
        </EmployeeFormGroup>


        {#if employee.cv?.nationality}
            <EmployeeFormGroup
                    {editing}
                    label="Staatsangehörigkeit"
                    labelFor="nationality"
                    bind:value={employee.cv.nationality}
                    data={nationalityOptions}
            >
                {employee.cv.nationality || ''}
            </EmployeeFormGroup>
        {/if}


    </svelte:fragment>
    <svelte:fragment slot="right">

        <EmployeeFormGroup
                {editing}
                label="Geschlecht"
                labelFor="gender"
                data={genderOptions}
                bind:value={employee.gender}>
            {genderOptions.find(option => option.value === employee.gender || '')?.name || ''}
        </EmployeeFormGroup>

        {#if employee.dateOfBirth}
            <div class="flex gap-2">
                <div class="flex-1">
                    <EmployeeFormGroup
                            {editing}
                            label="Geburtsdatum"
                            labelFor="dateOfBirth"
                            type="date"
                            extract={selected => employee.dateOfBirth = selected.value}
                            value={employee.dateOfBirth && typeof employee.dateOfBirth === 'string' ? employee.dateOfBirth.split(' ')[0] : employee.dateOfBirth.value.split(' ')[0]}>
                        {employee.dateOfBirth ? dayjs(asValue(employee.dateOfBirth), 'YYYY-MM-DD').format('DD.MM.YYYY') : ''}
                    </EmployeeFormGroup>
                </div>

                <div>{dayjs().diff(dayjs(asValue(employee.dateOfBirth)), 'years')}</div>
            </div>

        {/if}

        {#if employee.cv?.familyStatus}
            <EmployeeFormGroup
                    {editing}
                    label="Familienstand"
                    labelFor="martialStatus"
                    data={maritalStatusOptions}
                    bind:value={employee.cv.familyStatus}>
                {maritalStatusOptions.find(option => option.value === employee.cv.familyStatus)?.name || ''}
            </EmployeeFormGroup>
        {/if}

        <EmployeeFormGroup
                {editing}
                label="Quelle"
                labelFor="source"
                data={sourceOptions}
                bind:value={employee.reference}>
            {employee.reference}
        </EmployeeFormGroup>

        {#if employee.cv?.placeOfBirth}
            <EmployeeFormGroup
                    {editing}
                    label="Geburtsort"
                    bind:value={employee.cv.placeOfBirth}
                    labelFor="placeOfBirth">
                {employee.cv?.placeOfBirth || '-'}
            </EmployeeFormGroup>
        {/if}

        <EmployeeFormGroup
                {editing}
                label="Geburtsnachname"
                bind:value={employee.maidenName}
                labelFor="maidenName">
            {employee.maidenName || '-'}
        </EmployeeFormGroup>


    </svelte:fragment>
</EmployeeWidget>